import { SocketClient } from "cbcore-ts"


/**
 * Fires ProcessOverdueProcurementDeadline once per procurement whose
 * deadlineCountdown has already expired, closing the gap between the
 * countdown reaching zero and ProcurementDeadlineService's next scheduled
 * sweep (up to five minutes) — see RHProcurementLifecyclePresentation for why
 * a stale deadlineCountdown can otherwise linger on screen that long.
 *
 * One instance per view. Call reset() whenever the underlying row set is
 * freshly reloaded from the server, so a deadline that is still expired after
 * that reload (the same race, one more time) gets requested again.
 */
export class RHProcurementDeadlineResolutionTrigger {

    _requestedProcurementIds = new Set<string>()

    requestResolutionForExpiredDeadlines(
        deadlineCountdowns: { procurementId: string, deadlineDate: Date | string }[]
    ) {
        const now = Date.now()
        for (const countdown of deadlineCountdowns) {
            if (new Date(countdown.deadlineDate).getTime() > now) {
                continue
            }
            if (this._requestedProcurementIds.has(countdown.procurementId)) {
                continue
            }
            this._requestedProcurementIds.add(countdown.procurementId)
            SocketClient.ProcessOverdueProcurementDeadline({
                procurementId: countdown.procurementId
            }).catch(error => {
                console.error(
                    "RHProcurementDeadlineResolutionTrigger: failed to request resolution for",
                    countdown.procurementId,
                    error
                )
            })
        }
    }

    reset() {
        this._requestedProcurementIds.clear()
    }

}
